var map = {
	"./seamless1.jpg": 822,
	"./seamless2.jpg": 433,
	"./seamless3.jpg": 2388,
	"./seamless4.jpg": 8767,
	"./seamless5.jpg": 2386,
	"./seamless6.jpg": 1341,
	"./seamless7.jpg": 2128
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5878;